import ContinuePage from "@components/ContinuePage"
import { isHomeDesignFlow } from "@helpers/localStorage"

export default function StyleProfilePage() {
  if (isHomeDesignFlow()) {
    return <ContinuePage emoji="🏠" translationKey="styleProfileHomeDesign" />
  }
  return <ContinuePage emoji="✨" translationKey="styleProfile" />
}
